module.exports = __webpack_public_path__ + "img/1989SitePlanParkingArea_1.87b9fa5c.png";